import React from 'react';
import _ from "lodash";
import {Col, Grid, Row} from "react-bootstrap";
import TweetEmbed from "react-tweet-embed";
import YouTube from "react-youtube";
import {Page, PagePanel} from "../../../components/helpers/PagePanel";
import './../About.css'
import LoadingDiv from "../../../components/helpers/LoaderDiv";

const tweets = [
    // 2017 (still missing)
    '870884341282476032', '870994940217749505', '870693812556845057', '870679259299291140', '870677685197914113', '870942238985117696',
    '870999297973784577', '870895422360997888',
    // 2016
    '738738397846470656', '738744364848033792', '738749704834535424', '738761195705012224', '738767153135026176', '738849586421338112',
    '738851537506603008', '738866841758650368', '738906339737501696', '738974376381579264', '738986449731780608', '739014044829548545',
    '739168371342774272', '739330836865126400', '739360067535962112',
];
const slicedTweets = _.chunk(tweets, Math.floor(tweets.length / 2));
const youTubeOpts = {
    height: '390',
    width: '100%'
};
export const ImpressionsPage = () => (
    <Page>
        <PagePanel title="What others are saying">
            <p className="lead">Don't take it from us, here's what others has said:</p>
            <h2>Tweets about GR8Conf</h2>
            <Grid>
                <Row>
                    {slicedTweets.map((slice, index) => (
                        <Col xs={12} sm={6} key={index}>
                            {slice.map((tweetId) => (
                                <LoadingDiv key={tweetId}>
                                    <TweetEmbed id={tweetId} options={{theme: 'dark'}}/>
                                </LoadingDiv>
                            ))}
                        </Col>

                    ))}
                </Row>
            </Grid>
            <h2>Recap videos</h2>
            <Grid>
                <Row>
                    <Col xs={12} smPush={2} sm={8}>
                        <h3>2017</h3>
                        <LoadingDiv>
                            <YouTube videoId='U4o0ubURORo' opts={youTubeOpts}/>
                        </LoadingDiv>
                    </Col>
                    <Col xs={12} smPush={2} sm={8}>
                        <h3>2016</h3>
                        <LoadingDiv>
                            <YouTube videoId='9gGzCIA8TQg' opts={youTubeOpts}/>
                        </LoadingDiv>
                    </Col>
                </Row>
            </Grid>
        </PagePanel>
    </Page>
);


// WEBPACK FOOTER //
// ./src/pages/information/impressions/ImpressionsPage.js